import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchAssetsStats,
  fetchIdentitiesStats,
  fetchDatastoreStats,
  fetchIssueUberScore,
  fetchFirstAccountStatStatus,
  fetchIssuesStats,
  fetchRiskPlot,
  fetchDashboardStats,
  fetchDataFlows,
  fetchAchievements,
  fetchTrends,
  fetchDataNewFlows,
  manageDashboardView,
  fetchDatastoreRegions,
  fetchCloudIssues,
  fetchPolicyViolationFilters,
  fetchPolicyViolations,
  fetchLLMListing,
  fetchTrainingData,
  fetchSensitiveData,
  fetchAIRegions,
  fetcAIPolicyViolationFilters,
  fetchFrameworksData,
  fetchFrameworkDetailsData,
  fetchAITrainingData,
  fetchAllRegionsData,
  fetchFrameworkRegions,
  fetchLLMPolicyViolations,
  fetchFrameworkData,
  fetchDatasourceFiles,
  fetchFindingOverview,
  fetchFindings,
  fetchUserAccessData,
  fetchDocAccessData,
} from "../apis/dashboardAPI";
import { accountType } from "../../components/constants/constants";
import { getCustomerAccountType } from "../../utils/SessionHelper";

const firstAccountStats = {
  cdRiskLabel: "LOW",
  cdRiskScore: 0,
  description: null,
  first_acct_classification_complete: null,
  first_acct_risk_complete: null,
};

const initialState = {
  datastoreStats: null,
  issuesStats: null,
  assetsStats: null,
  identitiesStats: null,
  riskPlot: null,
  dataflow: null,
  issueUberScore: null,
  promptFilter: "week",
  sidebar: JSON.parse(localStorage.getItem("sidebarExpand")),
  dashboardIssueView: JSON.parse(localStorage.getItem("dashboardIssueView")),
  firstAccountStatus: firstAccountStats,
  // isIssueViewVisible: JSON.parse(localStorage.getItem("view")),
  isDashboardView: getCustomerAccountType() || null,
  policyCategories: [],
  policyViolationList: [],
  frameworkTopLabelListing: {
    isFetching: true,
    listing: {},
  },
};

// Async calls.
export const listDatastoreStats = createAsyncThunk(
  "dashboard/datastoreStats",
  async (params) => {
    const response = await fetchDatastoreStats(params);
    return response.data;
  }
);

export const listIssuesStats = createAsyncThunk(
  "dashboard/issuesStats",
  async (params) => {
    const response = await fetchIssuesStats(params);
    return response.data;
  }
);

export const listAssetsStats = createAsyncThunk(
  "dashboard/assetsStats",
  async (params) => {
    const response = await fetchAssetsStats(params);
    return response.data;
  }
);

export const listIdentitiesStats = createAsyncThunk(
  "dashboard/identitiesStats",
  async (params) => {
    const response = await fetchIdentitiesStats(params);
    return response.data;
  }
);

export const listRiskPlot = createAsyncThunk(
  "dashboard/riskplot",
  async (params) => {
    const response = await fetchRiskPlot(params);
    return response.data;
  }
);

export const firstAccountStatStatus = createAsyncThunk(
  "dashboard/firstAccountStatStatus",
  async (params) => {
    const response = await fetchFirstAccountStatStatus(params);
    return response.data;
  }
);

export const fetchDashboardStat = createAsyncThunk(
  "dashboard/fetchDashboardStat",
  async (params) => {
    const response = await fetchDashboardStats(params);
    return response.data;
  }
);

export const fetchDataFlowsSlice = createAsyncThunk(
  "dashboard/dataflow",
  async (params) => {
    const response = await fetchDataFlows(params);
    return response.data;
  }
);

export const fetchAchievementStats = createAsyncThunk(
  "dashboard/achievements",
  async (params) => {
    const response = await fetchAchievements(params);
    return response.data;
  }
);

export const fetchLLMModelsListingSlice = createAsyncThunk(
  "dashboard/llmmodels",
  async (params) => {
    const response = await fetchLLMListing(params);
    return response.data;
  }
);

export const fetchTrainingDataSlice = createAsyncThunk(
  "dashboard/trainingData",
  async (params) => {
    const response = await fetchTrainingData(params);
    return response.data;
  }
);

export const fetchAITrainingDataSlice = createAsyncThunk(
  "dashboard/trainingData",
  async (params) => {
    const response = await fetchAITrainingData(params);
    return response.data;
  }
);

export const fetchSensitiveDataSlice = createAsyncThunk(
  "dashboard/trainingData",
  async (params) => {
    const response = await fetchSensitiveData(params);
    return response.data;
  }
);

export const fetchTrendsStats = createAsyncThunk(
  "dashboard/achievements",
  async (params) => {
    const response = await fetchTrends(params);
    return response.data;
  }
);

export const fetchDataFlowsNewSlice = createAsyncThunk(
  "dashboard/dataflowNew",
  async (params) => {
    const response = await fetchDataNewFlows(params);
    return response.data;
  }
);

export const fetchIssueUberScoreSlice = createAsyncThunk(
  "dashboard/issueUberScore",
  async (params) => {
    const response = await fetchIssueUberScore(params);
    return response.data;
  }
);

export const manageDashboardViewSlice = createAsyncThunk(
  "dashboard/issueUberScore",
  async (params) => {
    const response = await manageDashboardView(params);
    return response.data;
  }
);

export const fetchDatastoreRegionsSlice = createAsyncThunk(
  "dashboard/regions",
  async (params) => {
    const response = await fetchDatastoreRegions(params);
    return response.data;
  }
);

export const fetchAllRegionsDataSlice = createAsyncThunk(
  "dashboard/regions",
  async (params) => {
    const response = await fetchAllRegionsData(params);
    return response.data;
  }
);

export const fetchAIRegionsSlice = createAsyncThunk(
  "dashboard/AI/regions",
  async (params) => {
    const response = await fetchAIRegions(params);
    return response.data;
  }
);

export const fetchFrameworkRegionsSlice = createAsyncThunk(
  "dashboard/Framework/regions",
  async (params) => {
    const response = await fetchFrameworkRegions(params);
    return response.data;
  }
);

export const fetchCloudIssuesSlice = createAsyncThunk(
  "dashboard/cloud",
  async (params) => {
    const response = await fetchCloudIssues(params);
    return response.data;
  }
);

export const fetchFrameworksSlice = createAsyncThunk(
  "dashboard/frameworks",
  async (params) => {
    const response = await fetchFrameworksData(params);
    return response.data;
  }
);

export const fetchFrameworkSlice = createAsyncThunk(
  "dashboard/frameworks",
  async (params) => {
    const response = await fetchFrameworkData(params);
    return response.data;
  }
);

export const fetchPolicyViolationFiltersSlice = createAsyncThunk(
  "dashboard/policyviolations/filter",
  async (params) => {
    const response = await fetchPolicyViolationFilters(params);
    return response.data;
  }
);

export const fetchAIPolicyViolationFiltersSlice = createAsyncThunk(
  "dashboard/policyviolations/filter",
  async (params) => {
    const response = await fetcAIPolicyViolationFilters(params);
    return response.data;
  }
);

export const fetchPolicyViolationsSlice = createAsyncThunk(
  "dashboard/policyviolations",
  async (params) => {
    const response = await fetchPolicyViolations(params);
    return response.data;
  }
);

export const fetchLLMPolicyViolationsSlice = createAsyncThunk(
  "dashboard/policyviolations",
  async (params) => {
    const response = await fetchLLMPolicyViolations(params);
    return response.data;
  }
);

export const fetchDatasourceFilesSlice = createAsyncThunk(
  "dashboard/frameworkTopLabelListing",
  async (params) => {
    const response = await fetchDatasourceFiles(params);
    return response.data;
  }
);

export const fetchFindingOverviewSlice = createAsyncThunk(
  "dashboard/findingOverview",
  async (params) => {
    const response = await fetchFindingOverview(params);
    return response.data;
  }
);

export const fetchFindingsSlice = createAsyncThunk(
  "dashboard/findings",
  async (params) => {
    const response = await fetchFindings(params);
    return response.data;
  }
);

export const fetchUserAccessDataSlice = createAsyncThunk(
  "dashboard/users",
  async (params) => {
    const response = await fetchUserAccessData(params);
    return response.data;
  }
);

export const fetchDocAccessDataSlice = createAsyncThunk(
  "dashboard/docs",
  async (params) => {
    const response = await fetchDocAccessData(params);
    return response.data;
  }
);

// Account slice for configuring reducers and actions.
export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    expandSidebar: (state) => {
      state.sidebar = true;
      localStorage.setItem("sidebarExpand", true);
      console.log("====== Showing sidebar =====");
    },
    minimizeSidebar: (state) => {
      state.sidebar = false;
      localStorage.setItem("sidebarExpand", false);
    },
    isDataView: (state) => {
      state.isDashboardView = accountType.Data;
      // localStorage.setItem("view", true);
    },
    isAIView: (state) => {
      state.isDashboardView = accountType.AI;
      // localStorage.setItem("view", false);
    },
    setPromptTimeFilter: (state, action) => {
      console.log(action, state.promptFilter);
      const filter = action.payload;
      state.promptFilter = filter;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(listDatastoreStats.fulfilled, (state, action) => {
        state.datastoreStats = action.payload;
      })
      .addCase(listDatastoreStats.rejected, (state) => {
        state.datastoreStats = {};
      })
      .addCase(listIssuesStats.fulfilled, (state, action) => {
        state.issuesStats = action.payload;
      })
      .addCase(listIssuesStats.rejected, (state) => {
        state.issuesStats = {};
      })

      .addCase(listAssetsStats.fulfilled, (state, action) => {
        state.assetsStats = action.payload;
      })
      .addCase(listAssetsStats.rejected, (state) => {
        state.assetsStats = {};
      })

      .addCase(listIdentitiesStats.fulfilled, (state, action) => {
        state.identitiesStats = action.payload;
      })
      .addCase(listIdentitiesStats.rejected, (state) => {
        state.identitiesStats = {};
      })

      .addCase(listRiskPlot.fulfilled, (state, action) => {
        state.riskPlot = action.payload;
      })
      .addCase(listRiskPlot.rejected, (state) => {
        state.riskPlot = {};
      })
      .addCase(fetchDataFlowsSlice.fulfilled, (state, action) => {
        state.dataflow = action.payload;
      })
      .addCase(fetchDataFlowsSlice.rejected, (state) => {
        state.dataflow = {};
      })
      .addCase(fetchIssueUberScoreSlice.fulfilled, (state, action) => {
        state.issueUberScore = action.payload;
      })
      .addCase(fetchLLMPolicyViolationsSlice.rejected, (state, action) => {
        state.policyViolationList = [];
      })
      .addCase(fetchLLMPolicyViolationsSlice.fulfilled, (state, action) => {
        state.policyViolationList = action.payload;
      })
      .addCase(fetchIssueUberScoreSlice.rejected, (state) => {
        state.issueUberScore = {};
      })
      .addCase(firstAccountStatStatus.fulfilled, (state, action) => {
        // let test = { ...action.payload };
        // test.first_acct_classification_complete =
        //   action.payload.first_acct_classification_complete;
        // test.first_acct_classification_complete = null;
        // test.first_acct_risk_complete = null;
        // state.firstAccountStatus = test;

        state.firstAccountStatus = action?.payload?.err
          ? firstAccountStats
          : action.payload;
      })
      .addCase(firstAccountStatStatus.rejected, (state) => {
        state.firstAccountStatus = firstAccountStats;
      })
      .addCase(
        fetchAIPolicyViolationFiltersSlice.fulfilled,
        (state, action) => {
          state.policyCategories = action?.payload?.err ? [] : action.payload;
        }
      )
      .addCase(fetchDatasourceFilesSlice.fulfilled, (state, action) => {
        state.frameworkTopLabelListing = {
          isFetching: false,
          listing: action.payload,
        };
      })
      .addCase(fetchDatasourceFilesSlice.rejected, (state) => {
        state.frameworkTopLabelListing = {
          isFetching: false,
          listing: {},
        };
      });
  },
});
export const {
  expandSidebar,
  minimizeSidebar,
  isDataView,
  isAIView,
  setPromptTimeFilter,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
